import { Controller } from '@hotwired/stimulus'

const ICONS_ONLY = 'hero-template-v2-trusted--icons-only'

// Named logo strip (HeroTemplateV2Component icons_list with item texts and
// icons_only_on_wrap): the names show while every logo fits on one line; once
// the list would wrap, the names go and only the icons stay. Re-checked when
// the width changes, when a logo loads or fails (it has no width before) and
// when web fonts finish loading.
export default class extends Controller {
  static targets = ['list']

  connect() {
    this.connected = true
    this.width = null
    this.refit = () => {
      if (this.connected) this.fit()
    }
    this.observer = new ResizeObserver(([entry]) => {
      // Hiding the names changes the height only — skip those notifications
      if (entry.contentRect.width === this.width) return
      this.width = entry.contentRect.width
      this.fit()
    })
    this.observer.observe(this.element.parentElement)
    this.pendingImages = [...this.listTarget.querySelectorAll('img')].filter(
      img => !img.complete
    )
    this.pendingImages.forEach(img => {
      img.addEventListener('load', this.refit)
      img.addEventListener('error', this.refit)
    })
    document.fonts?.addEventListener('loadingdone', this.refit)
    document.fonts?.ready.then(this.refit)
  }

  disconnect() {
    this.connected = false
    this.observer.disconnect()
    this.pendingImages.forEach(img => {
      img.removeEventListener('load', this.refit)
      img.removeEventListener('error', this.refit)
    })
    document.fonts?.removeEventListener('loadingdone', this.refit)
  }

  fit() {
    this.element.classList.remove(ICONS_ONLY)
    const items = this.listTarget.children
    const first = items[0]
    const last = items[items.length - 1]
    // Wrapped once the last logo starts below the first one's bottom edge;
    // logos of different heights share a line centred, so their tops differ
    const wraps =
      items.length > 1 && last.offsetTop >= first.offsetTop + first.offsetHeight
    this.element.classList.toggle(ICONS_ONLY, wraps)
  }
}
